"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.Tooltip = exports.TimeRangeLabel = exports.TimeRangeButtonsContainer = exports.TimeRangeButton = exports.TimelapseModal = exports.TimeAxisContainer = exports.Time = exports.StepMarkers = exports.StepMarker = exports.SmallPopup = exports.RoundMarker = exports.ProgressFiller = exports.ProgressBar = exports.NavigationButtonsContainer = exports.NavigationButton = exports.MobileDateContainer = exports.MobileAxisContainer = exports.DesktopAxisContainer = exports.DateContainer = exports.Date = exports.CancelButtonX = exports.AlertInfo = void 0;
const reactjs_popup_1 = __importDefault(require("reactjs-popup"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const media_1 = require("../../../../utils/media");
const TimelapseModal = (0, styled_components_1.default)(reactjs_popup_1.default) `
  width: 100%;

  &-overlay {
    z-index: 2;
  }

  &-content {
    width: 100%;
    height: auto;
    padding: 1rem;
    overflow: visible;
    flex-direction: row;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    top: 5rem;

    @media ${media_1.media.smallDesktop} {
      padding-bottom: 1.25rem;
      align-items: flex-end;
      bottom: 10rem;
      top: auto;
    }
  }
`;
exports.TimelapseModal = TimelapseModal;
const CancelButtonX = styled_components_1.default.button `
  border: none;
  background-color: transparent;
  position: relative;
  top: auto;
  right: 0;
  bottom: 2.8rem;
  left: 0;
  height: fit-content;
  align-self: flex-end;
  cursor: pointer;
  @media ${media_1.media.smallDesktop} {
    top: -14rem;
    left: 97%;
    right: 0;
    bottom: 0;
  }
  @media ${media_1.media.desktop} {
    top: -11rem;
    left: 101%;
  }
  body:not(.user-is-tabbing) &:focus-visible {
    outline: none;
  }
`;
exports.CancelButtonX = CancelButtonX;
const SmallPopup = (0, styled_components_1.default)(reactjs_popup_1.default) `
  width: 100%;
  height: auto;

  &-overlay {
  }

  &-content {
    background-color: ${colors_1.white};
    opacity: 1;
    border-radius: 8px;
    position: relative;
    padding: 1rem;
    box-shadow: 2px 2px 4px 0px ${colors_1.gray900};
    z-index: 6;
    display: flex;
    width: 20rem;
    height: 7rem;
  }
`;
exports.SmallPopup = SmallPopup;
const AlertInfo = styled_components_1.default.span `
  font-size: 1.2rem;
  color: ${colors_1.gray400};
  margin: 0;
  padding: 0;
  text-align: center;
  line-height: 1.8rem;
  align-items: center;
  display: flex;
  @media ${media_1.media.smallDesktop} {
    font-size: 1.4rem;
  }
`;
exports.AlertInfo = AlertInfo;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media ${media_1.media.smallDesktop} {
    gap: 1.6rem;
  }
`;
exports.Wrapper = Wrapper;
const TimeAxisContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr auto;
  width: calc(100vw - 3rem);
  height: 100%;
  background-color: ${colors_1.white};
  gap: 1.2rem;
  padding: 2rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 2px 2px 4px 0px ${colors_1.gray900};
  @media ${media_1.media.smallDesktop} {
    width: 100%;
    max-width: 115rem;
    min-width: 50rem;
    grid-template-rows: auto;
    grid-template-columns: 1fr 5fr;
    padding: 1rem;
  }
`;
exports.TimeAxisContainer = TimeAxisContainer;
const NavigationButton = styled_components_1.default.button `
  border: none;
  background-color: transparent;
  cursor: pointer;
`;
exports.NavigationButton = NavigationButton;
const NavigationButtonsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.6rem;

  @media ${media_1.media.smallDesktop} {
    gap: 1rem;
    align-self: flex-end;
  }
`;
exports.NavigationButtonsContainer = NavigationButtonsContainer;
const DesktopAxisContainer = styled_components_1.default.div `
  display: none;
  @media ${media_1.media.smallDesktop} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;
exports.DesktopAxisContainer = DesktopAxisContainer;
const MobileAxisContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  grid-column: 1 / 3;
  grid-row: 3 / 3;
  padding-left: 0.8rem;
  @media ${media_1.media.smallDesktop} {
    display: none;
  }
`;
exports.MobileAxisContainer = MobileAxisContainer;
const ProgressBar = styled_components_1.default.div `
  width: 100%;
  height: 6px;
  background-color: ${colors_1.gray500};
  position: relative;
  border-radius: 1rem;
  cursor: pointer;
  touch-action: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;

  @media ${media_1.media.smallDesktop} {
    height: 2px;
    border-radius: 0;
  }
`;
exports.ProgressBar = ProgressBar;
const ProgressFiller = styled_components_1.default.div `
  height: 6px;
  background-color: ${colors_1.acBlue};
  border-radius: 1rem;
  transition: width ${({ $isDragging }) => ($isDragging ? "0.05s" : "0.2s")}
    ease-in-out;

  @media ${media_1.media.smallDesktop} {
    height: 4px;
    background-color: ${colors_1.acBlue};
    margin-top: -0.1rem;
    border-radius: 0;
  }
`;
exports.ProgressFiller = ProgressFiller;
const StepMarkers = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1rem;
  width: 100%;
  @media ${media_1.media.smallDesktop} {
    top: -6px;
    left: 0;
    right: 0;
    height: 1rem;
  }
`;
exports.StepMarkers = StepMarkers;
const StepMarker = styled_components_1.default.div `
  left: ${({ $position }) => `${$position}%`};
  position: absolute;
  width: 0.1rem;
  height: 0.6rem;
  background-color: ${({ $isActive }) => ($isActive ? colors_1.acBlue : colors_1.white)};
  transform: scale(1);
  transition: background-color
    ${({ $isDragging }) => ($isDragging ? "0.05s" : "0.2s")} ease-in-out;
  @media ${media_1.media.smallDesktop} {
    height: 1.4rem;
    background-color: ${({ $isActive }) => ($isActive ? colors_1.acBlue : colors_1.gray500)};
  }
`;
exports.StepMarker = StepMarker;
const DateContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${colors_1.gray400};
  width: 10rem;
  gap: 0.5rem;
`;
exports.DateContainer = DateContainer;
const MobileDateContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: 3.2rem;
  border-radius: 1.2rem;
  border: 1px solid ${colors_1.grayStroke};
  padding: 2rem 0.5rem;
  color: ${colors_1.acBlue};
  justify-content: center;
  align-items: center;
  gap: 1rem;
  @media ${media_1.media.smallDesktop} {
    display: none;
  }
`;
exports.MobileDateContainer = MobileDateContainer;
const Time = styled_components_1.default.span `
  font-size: 1.2rem;
  @media ${media_1.media.smallDesktop} {
    font-size: 1.2rem;
    font-weight: 400;
  }
`;
exports.Time = Time;
const Date = styled_components_1.default.span `
  font-size: 1.6rem;
  font-weight: 500;
  @media ${media_1.media.smallDesktop} {
    font-size: 1.4rem;
    font-weight: 500;
  }
`;
exports.Date = Date;
const RoundMarker = styled_components_1.default.div `
  position: absolute;
  top: -6px;
  left: ${({ $position }) => `${$position}%`};
  width: 1.6rem;
  height: 1.6rem;
  background-color: ${colors_1.acBlue};
  border-radius: 50%;
  transform: translateX(-50%);
  transition: left ${({ $isDragging }) => ($isDragging ? "0.05s" : "0.2s")}
    ease-in-out;
  z-index: 1;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;

  @media ${media_1.media.smallDesktop} {
    top: -8px;
  }
`;
exports.RoundMarker = RoundMarker;
const Tooltip = styled_components_1.default.div `
  display: flex;
  background-color: ${colors_1.white};
  color: ${colors_1.acBlueDark};
  border: 2px solid ${colors_1.acBlue};
  padding: 1rem;
  gap: 1rem;
  border-radius: 0.5rem;
  font-size: 1.2rem;
  text-align: center;
  white-space: nowrap;
  position: absolute;
  bottom: 140%;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: ${colors_1.acBlue} transparent transparent transparent;
  }
`;
exports.Tooltip = Tooltip;
const TimeRangeButtonsContainer = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  width: 100%;

  @media ${media_1.media.smallDesktop} {
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1rem;
    background-color: ${colors_1.white}80;
    padding: 0.4rem 0.8rem;
    width: fit-content;
    border-radius: 8px;
  }
`;
exports.TimeRangeButtonsContainer = TimeRangeButtonsContainer;
const TimeRangeButton = styled_components_1.default.button `
  padding: 0.7rem 1.5rem;
  margin: 0 5px;
  background-color: ${colors_1.white};
  color: ${({ $isActive }) => ($isActive ? colors_1.acBlueDark : colors_1.gray300)};
  box-sizing: border-box;
  border: 2px solid ${({ $isActive }) => ($isActive ? colors_1.acBlue : "transparent")};
  border-radius: 5px;
  box-shadow: 2px 2px 4px 0px rgba(76, 86, 96, 0.1);
  font-size: 1.2rem;
  margin: 0;

  cursor: pointer;

  @media ${media_1.media.smallDesktop} {
    background-color: ${colors_1.white};
    border: 2px solid ${({ $isActive }) => ($isActive ? colors_1.acBlue : "transparent")};
    color: ${({ $isActive }) => ($isActive ? colors_1.acBlueDark : colors_1.gray300)};
    &:hover {
      border-color: ${colors_1.acBlue};
      color: ${colors_1.acBlueDark};
    }
  }
`;
exports.TimeRangeButton = TimeRangeButton;
const TimeRangeLabel = styled_components_1.default.span `
  display: none;
  @media ${media_1.media.smallDesktop} {
    display: flex;
    font-size: 1.2rem;
    color: ${colors_1.gray400};
  }
`;
exports.TimeRangeLabel = TimeRangeLabel;
